import MateriasPeligrosasADRClass from "src/app/model/api/datos/materiasPeligrosasADRClass";
import Paging from "src/app/model/api/generic/paging";
import DatabaseTable from "src/app/model/database/generic/databaseTable";

export default class MateriasPeligrosasAdrTable extends DatabaseTable<MateriasPeligrosasADRClass> {

  public async getAll(): Promise<MateriasPeligrosasADRClass[]> {
    return await this.GetAllRecords()
  }

  public async getById(Id: number): Promise<MateriasPeligrosasADRClass> {
    let records = await this.GetRecordsById(0, 1, Id, Id)
    if (records.length) {
      return records[0]
    }
    return null
  }

  public async getPaged(start: number, limit: number): Promise<Paging<MateriasPeligrosasADRClass>> {
    let count = await this.GetRecordsCount()
    let data = await this.GetRecordsPage(start, limit)

    let result = new Paging<MateriasPeligrosasADRClass>()
    result.page = Math.floor(start / limit) + 1
    result.total = count
    result.totalPages = Math.ceil(result.total / limit)
    result.collection = data
    result.count = data.length
    return result
  }

  public async update(record: MateriasPeligrosasADRClass): Promise<void> {
    await this.UpdateRecord(record)
  }

  public async delete(record: MateriasPeligrosasADRClass): Promise<void> {
    await this.DeleteRecord(record.IdMateria)
  }

  public async deleteById(Id: number): Promise<void> {
    if (!Id) return
    await this.DeleteRecord(Id)
  }

  // value es 0/1 (no boolean: IndexedDB no admite boolean como clave de índice válida).
  public async getKeysByBooleanIndex(indexName: string, value: 0 | 1): Promise<number[]> {
    return await this.GetKeysByIndex(indexName, value)
  }

  public async getByIds(ids: number[]): Promise<MateriasPeligrosasADRClass[]> {
    return await this.GetRecordsByKeys(ids)
  }

}